import tags from '../tags';

const {
  elements: { cold, fire, lightning, physical, holy },
  skillTypes: {
    healing,
    cc,
    dot,
    channeling,
    weaken,
    resource,
    cooldown,
    damageBoost,
    toughness,
    mobility,
    pet,
  },
  skillTrees: { primary, secondary, defensive, techniques, focus, mantras },
} = tags;

export default [
  {
    name: 'Fists of Thunder',
    runes: [
      {
        name: 'No rune',
        tags: [primary, lightning, mobility],
      },
      {
        name: 'Thunderclap',
        tags: [primary, lightning, mobility, cc],
      },
      {
        name: 'Wind Blast',
        tags: [primary, cold, mobility, cc],
      },
      {
        name: 'Static Charge',
        tags: [primary, lightning, mobility],
      },
      {
        name: 'Quickening',
        tags: [primary, physical, mobility],
      },
      {
        name: 'Bounding Light',
        tags: [primary, holy, mobility],
      },
    ],
  },
  {
    name: 'Lashing Tail Kick',
    runes: [
      {
        name: 'No rune',
        tags: [secondary, physical],
      },
      {
        name: 'Vulture Claw Kick',
        tags: [secondary, fire, dot],
      },
      {
        name: 'Sweeping Armada',
        tags: [secondary, physical],
      },
      {
        name: 'Spinning Flame Kick',
        tags: [secondary, fire],
      },
      {
        name: 'Scorpion Sting',
        tags: [secondary, lightning, cc],
      },
      {
        name: 'Hand of Ytar',
        tags: [secondary, cold, cc],
      },
    ],
  },
  {
    name: 'Deadly Reach',
    runes: [
      {
        name: 'No rune',
        tags: [primary, cc, physical],
      },
      {
        name: 'Piercing Trident',
        tags: [primary, cc, physical],
      },
      {
        name: 'Searing Grasp',
        tags: [primary, cc, fire],
      },
      {
        name: 'Scattered Blows',
        tags: [primary, cc, lightning],
      },
      {
        name: 'Strike from Beyond',
        tags: [primary, cc, cold, resource],
      },
      {
        name: 'Foresight',
        tags: [primary, cc, physical, damageBoost],
      },
    ],
  },
  {
    name: 'Blinding Flash',
    runes: [
      {
        name: 'No rune',
        tags: [cooldown, cc, weaken, defensive, holy],
      },
      {
        name: 'Self Reflection',
        tags: [cooldown, cc, weaken, defensive, holy],
      },
      {
        name: 'Mystifying Light',
        tags: [cooldown, cc, weaken, defensive, holy],
      },
      {
        name: 'Replenishing Light',
        tags: [cooldown, cc, weaken, defensive, resource, holy],
      },
      {
        name: 'Crippling Light',
        tags: [cooldown, cc, weaken, defensive, holy],
      },
      {
        name: 'Faith in the Light',
        tags: [cooldown, cc, weaken, defensive, damageBoost, holy],
      },
    ],
  },
  {
    name: 'Tempest Rush',
    runes: [
      {
        name: 'No rune',
        tags: [secondary, channeling, physical],
      },
      {
        name: 'Northern Breeze',
        tags: [secondary, channeling, holy],
      },
      {
        name: 'Tailwind',
        tags: [secondary, channeling, physical, mobility],
      },
      {
        name: 'Flurry',
        tags: [secondary, channeling, cold],
      },
      {
        name: 'Electric Field',
        tags: [secondary, channeling, lightning],
      },
      {
        name: 'Bluster',
        tags: [secondary, channeling, cc, fire],
      },
    ],
  },
  {
    name: 'Breath of Heaven',
    runes: [
      {
        name: 'No rune',
        tags: [cooldown, healing, defensive, holy],
      },
      {
        name: 'Circle of Scorn',
        tags: [cooldown, healing, defensive, holy],
      },
      {
        name: 'Circle of Life',
        tags: [cooldown, healing, defensive, holy],
      },
      {
        name: 'Blazing Wrath',
        tags: [cooldown, healing, defensive, damageBoost, holy],
      },
      {
        name: 'Infused with Light',
        tags: [cooldown, healing, defensive, resource, holy],
      },
      {
        name: 'Zephyr',
        tags: [cooldown, healing, defensive, mobility, holy],
      },
    ],
  },
  {
    name: 'Dashing Strike',
    runes: [
      {
        name: 'No rune',
        tags: [mobility, techniques, physical],
      },
      {
        name: 'Way of the Falling Star',
        tags: [mobility, techniques, holy],
      },
      {
        name: 'Blinding Speed',
        tags: [mobility, techniques, cold, defensive],
      },
      {
        name: 'Quicksilver',
        tags: [mobility, techniques, lightning],
      },
      {
        name: 'Radiance',
        tags: [mobility, techniques, fire, damageBoost],
      },
      {
        name: 'Barrage',
        tags: [mobility, techniques, physical, dot],
      },
    ],
  },
  {
    name: 'Crippling Wave',
    runes: [
      {
        name: 'No rune',
        tags: [primary, physical, cc, weaken],
      },
      {
        name: 'Mangle',
        tags: [primary, fire, cc, weaken],
      },
      {
        name: 'Concussion',
        tags: [primary, physical, cc, weaken],
      },
      {
        name: 'Rising Tide',
        tags: [primary, holy, cc, weaken, resource],
      },
      {
        name: 'Tsunami',
        tags: [primary, cold, cc, weaken],
      },
      {
        name: 'Breaking Wave',
        tags: [primary, physical, cc, weaken],
      },
    ],
  },
  {
    name: 'Wave of Light',
    runes: [
      {
        name: 'No rune',
        tags: [holy, secondary],
      },
      {
        name: 'Wall of Light',
        tags: [physical, secondary, cc],
      },
      {
        name: 'Explosive Light',
        tags: [fire, secondary],
      },
      {
        name: 'Empowered Wave',
        tags: [holy, secondary],
      },
      {
        name: 'Shattering Light',
        tags: [cold, secondary],
      },
      {
        name: 'Pillar of the Ancients',
        tags: [lightning, secondary, cc],
      },
    ],
  },
  {
    name: 'Exploding Palm',
    runes: [
      {
        name: 'No rune',
        tags: [dot, physical, techniques],
      },
      {
        name: 'The Flesh is Weak',
        tags: [dot, physical, techniques, weaken],
      },
      {
        name: 'Strong Spirit',
        tags: [dot, holy, techniques, resource],
      },
      {
        name: 'Impending Doom',
        tags: [cold, techniques],
      },
      {
        name: 'Shocking Grasp',
        tags: [dot, lightning, techniques],
      },
      {
        name: 'Essence Burn',
        tags: [dot, fire, techniques],
      },
    ],
  },
  {
    name: 'Cyclone Strike',
    runes: [
      {
        name: 'No rune',
        tags: [cc, holy, focus],
      },
      {
        name: 'Eye of the Storm',
        tags: [cc, lightning, focus],
      },
      {
        name: 'Implosion',
        tags: [cc, holy, focus],
      },
      {
        name: 'Sunburst',
        tags: [cc, fire, focus],
      },
      {
        name: 'Wall of Wind',
        tags: [cc, cold, focus],
      },
      {
        name: 'Soothing Breeze',
        tags: [cc, holy, focus, healing],
      },
    ],
  },
  {
    name: 'Way of the Hundred Fists',
    runes: [
      {
        name: 'No rune',
        tags: [primary, physical],
      },
      {
        name: 'Hands of Lightning',
        tags: [primary, lightning],
      },
      {
        name: 'Blazing Fists',
        tags: [primary, fire, mobility, damageBoost],
      },
      {
        name: 'Fists of Fury',
        tags: [primary, holy, mobility],
      },
      {
        name: 'Assimilation',
        tags: [primary, physical, damageBoost],
      },
      {
        name: 'Windforce Flurry',
        tags: [primary, cold],
      },
    ],
  },
  {
    name: 'Serenity',
    runes: [
      {
        name: 'No rune',
        tags: [defensive, toughness, cooldown, holy],
      },
      {
        name: 'Peaceful Repose',
        tags: [defensive, toughness, cooldown, healing, holy],
      },
      {
        name: 'Unwelcome Disturbance',
        tags: [defensive, toughness, cooldown, physical],
      },
      {
        name: 'Tranquility',
        tags: [defensive, toughness, cooldown, holy],
      },
      {
        name: 'Ascension',
        tags: [defensive, toughness, cooldown, holy],
      },
      {
        name: 'Instant Karma',
        tags: [defensive, toughness, cooldown, mobility, holy],
      },
    ],
  },
  {
    name: 'Seven-Sided Strike',
    runes: [
      {
        name: 'No rune',
        tags: [cooldown, focus, physical],
      },
      {
        name: 'Sudden Assault',
        tags: [cooldown, focus, lightning, mobility],
      },
      {
        name: 'Incinerate',
        tags: [cooldown, focus, fire, dot],
      },
      {
        name: 'Pandemonium',
        tags: [cooldown, focus, cold],
      },
      {
        name: 'Sustained Attack',
        tags: [cooldown, focus, physical],
      },
      {
        name: 'Fulminating Onslaught',
        tags: [cooldown, focus, holy],
      },
    ],
  },
  {
    name: 'Mantra of Salvation',
    runes: [
      {
        name: 'No rune',
        tags: [toughness, mantras, physical],
      },
      {
        name: 'Hard Target',
        tags: [toughness, mantras, physical],
      },
      {
        name: 'Divine Protection',
        tags: [toughness, mantras, physical],
      },
      {
        name: 'Wind through the Reeds',
        tags: [toughness, mantras, mobility, physical],
      },
      {
        name: 'Perseverance',
        tags: [toughness, mantras, physical],
      },
      {
        name: 'Agility',
        tags: [toughness, mantras, physical],
      },
    ],
  },
  {
    name: 'Sweeping Wind',
    runes: [
      {
        name: 'No rune',
        tags: [techniques, physical],
      },
      {
        name: 'Master of Wind',
        tags: [techniques, cold, cc],
      },
      {
        name: 'Blade Storm',
        tags: [techniques, physical],
      },
      {
        name: 'Fire Storm',
        tags: [techniques, fire],
      },
      {
        name: 'Inner Storm',
        tags: [techniques, holy, resource],
      },
      {
        name: 'Cyclone',
        tags: [techniques, lightning],
      },
    ],
  },
  {
    name: 'Mantra of Retribution',
    runes: [
      {
        name: 'No rune',
        tags: [holy, mantras],
      },
      {
        name: 'Retaliation',
        tags: [fire, mantras],
      },
      {
        name: 'Transgression',
        tags: [holy, mantras, damageBoost],
      },
      {
        name: 'Indignation',
        tags: [holy, mantras, cc],
      },
      {
        name: 'Against All Odds',
        tags: [holy, mantras, resource],
      },
      {
        name: 'Collateral Damage',
        tags: [holy, mantras],
      },
    ],
  },
  {
    name: 'Inner Sanctuary',
    runes: [
      {
        name: 'No rune',
        tags: [cooldown, toughness, defensive, holy],
      },
      {
        name: 'Sanctified Ground',
        tags: [cooldown, toughness, defensive, holy],
      },
      {
        name: 'Safe Haven',
        tags: [cooldown, toughness, defensive, healing, holy],
      },
      {
        name: 'Temple of Protection',
        tags: [cooldown, toughness, defensive, holy],
      },
      {
        name: 'Intervene',
        tags: [cooldown, toughness, defensive, holy],
      },
      {
        name: 'Forbidden Palace',
        tags: [cooldown, toughness, defensive, cc, holy],
      },
    ],
  },
  {
    name: 'Mystic Ally',
    runes: [
      {
        name: 'No rune',
        tags: [cooldown, pet, physical, focus],
      },
      {
        name: 'Water Ally',
        tags: [cooldown, pet, cold, focus, cc],
      },
      {
        name: 'Fire Ally',
        tags: [cooldown, pet, fire, focus, damageBoost],
      },
      {
        name: 'Air Ally',
        tags: [cooldown, pet, physical, focus, resource],
      },
      {
        name: 'Enduring Ally',
        tags: [cooldown, pet, physical, focus, healing],
      },
      {
        name: 'Earth Ally',
        tags: [cooldown, pet, physical, focus, cc, toughness],
      },
    ],
  },
  {
    name: 'Mantra of Healing',
    runes: [
      {
        name: 'No rune',
        tags: [toughness, healing, mantras, holy],
      },
      {
        name: 'Sustenance',
        tags: [toughness, healing, mantras, holy],
      },
      {
        name: 'Circular Breathing',
        tags: [toughness, healing, mantras, resource, holy],
      },
      {
        name: 'Boon of Inspiration',
        tags: [toughness, healing, mantras, holy],
      },
      {
        name: 'Heavenly Body',
        tags: [toughness, healing, mantras, holy],
      },
      {
        name: 'Time of Need',
        tags: [toughness, healing, mantras, holy],
      },
    ],
  },
  {
    name: 'Mantra of Conviction',
    runes: [
      {
        name: 'No rune',
        tags: [damageBoost, mantras, physical],
      },
      {
        name: 'Overawe',
        tags: [damageBoost, mantras, physical],
      },
      {
        name: 'Intimidation',
        tags: [damageBoost, mantras, weaken, physical],
      },
      {
        name: 'Dishearten',
        tags: [damageBoost, mantras, cc, physical],
      },
      {
        name: 'Annihilation',
        tags: [damageBoost, mantras, mobility, physical],
      },
      {
        name: 'Submission',
        tags: [damageBoost, mantras, holy],
      },
    ],
  },
  {
    name: 'Epiphany',
    runes: [
      {
        name: 'No rune',
        tags: [cooldown, mobility, resource, focus, holy],
      },
      {
        name: 'Desert Shroud',
        tags: [cooldown, mobility, resource, focus, toughness, physical],
      },
      {
        name: 'Ascendance',
        tags: [cooldown, mobility, resource, focus, cc, lightning],
      },
      {
        name: 'Soothing Mist',
        tags: [cooldown, mobility, resource, focus, healing, cold],
      },
      {
        name: 'Insight',
        tags: [cooldown, mobility, resource, focus, holy],
      },
      {
        name: 'Inner Fire',
        tags: [cooldown, mobility, resource, focus, fire],
      },
    ],
  },
];
